@if (orderTemplate.categoryGroupedEntries?.length > 0) {
    <div class="sub-header row bg-petrol-light no-gutters p-2 sub-header-line align-items-center d-none d-lg-flex">
        <div class="col-12 col-lg-4">
            <span class="text-bold">{{ 'aimo.cart.item.product' | cxTranslate }}</span>
        </div>
        <div class="col-3">
            <div class="row no-gutters">
                <div class="col-6">
                    <span class="text-bold">{{ 'aimo.cart.item.basePrice' | cxTranslate }}</span>
                    <br />
                    {{ 'aimo.cart.item.notax' | cxTranslate }}
                </div>
                <div class="col-6">
                    <span class="text-bold">{{ 'aimo.cart.item.comparisonPrice' | cxTranslate }}</span>
                    <br />
                    {{ 'aimo.cart.item.notax' | cxTranslate }}
                </div>
            </div>
        </div>
        @if (!baseOrder) {
            <div class="col-3">
                <div class="row no-gutters">
                    <div class="col-6">
                        <span class="text-bold">{{ 'aimo.cart.item.availability' | cxTranslate }}</span>
                    </div>
                    <div class="col-6">
                        <span class="text-bold">{{ 'aimo.product.closingTime' | cxTranslate }}</span>
                    </div>
                </div>
            </div>
        }

        <div [ngClass]="baseOrder ? 'col-3' : 'col-2'">
            <div class="row no-gutters">
                @if (baseOrder) {
                    <div class="col-6">
                        <span class="text-bold">{{ 'aimo.cart.item.availability' | cxTranslate }}</span>
                    </div>
                }
                <div
                    [ngClass]="{
                        'col-6': baseOrder,
                        'col-12': !baseOrder,
                    }">
                    <span class="text-bold" [ngClass]="{ 'pl-4': !baseOrder }">{{
                        'aimo.cart.item.quantity' | cxTranslate
                    }}</span>
                </div>
            </div>
        </div>

        @if (baseOrder) {
            <div class="col-2">
                <span class="text-bold">{{ 'aimo.cart.item.total' | cxTranslate }}</span>
            </div>
        }
    </div>
    <div class="d-none" [ngClass]="printViewWithTable ? 'print' : ''">
        <div class="sub-header py-2 align-items-end row d-flex">
            <div class="col-6"></div>
            <div class="col-1">
                <div class="date-slot-for-print"></div>
            </div>
            <div class="col-1">
                <div class="date-slot-for-print"></div>
            </div>
            <div class="col-1">
                <div class="date-slot-for-print"></div>
            </div>
            <div class="col-1">
                <div class="date-slot-for-print"></div>
            </div>
            <div class="col-1">
                <div class="date-slot-for-print"></div>
            </div>
            <div class="col-1">
                <div class="date-slot-for-print"></div>
            </div>
        </div>
    </div>
    <div class="row no-gutters">
        @for (
            categoryGroupedEntry of orderTemplate.categoryGroupedEntries;
            track categoryGroupedEntry.title;
            let idx1 = $index
        ) {
            @if (categoryGroupedEntry.title) {
                <div
                    class="col-12 sub-header sub-header-line bg-light-grey p-2 text-bold"
                    [ngClass]="printViewWithTable ? 'noPrint' : ''">
                    {{ categoryGroupedEntry.title }}
                </div>
            }
            @for (entry of categoryGroupedEntry.entries; track entry.entryNumber; let idx2 = $index) {
                <aimo-order-template-item
                    [printViewWithTable]="printViewWithTable"
                    [alreadyAddedToCart]="getAlreadyAddedToCart(cart, entry)"
                    [baseOrder]="baseOrder"
                    class="col-12"
                    [entry]="entry"
                    [cart]="orderTemplate"
                    [idSuffix]="idx1 + '_' + idx2"
                    [gtmProductAttributes]="createGtmAttributes(idx1, entry)">
                </aimo-order-template-item>
            }
        }
    </div>
}
@if (orderTemplate.categoryGroupedEntries?.length <= 0) {
    <div class="pt-4 pb-4">
        <h3 class="mb-0 text-default">
            {{ (baseOrder ? 'aimo.baseorders.noItems' : 'aimo.ordertemplate.noOrders') | cxTranslate }}
        </h3>
    </div>
}
